import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RegistrationVerify } from 'src/app/models/registration-verify.model';
import { RegistrationService } from 'src/app/services/registration.service';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-registration-verify-details',
  templateUrl: './registration-verify-details.component.html',
  styleUrls: ['./registration-verify-details.component.scss']
})
export class RegistrationVerifyDetailsComponent implements OnInit, AfterViewInit {
  @Input() registrationVerifyInput;
  isSendFeedback: any;
  id: any;
  isEdit: any = false;
  isAdmin: any;
  registrationVerify: RegistrationVerify = new RegistrationVerify();
  constructor(private registrationService: RegistrationService, private router: Router, private route: ActivatedRoute, private afAuth: AngularFireAuth) { }

  ngOnInit(): void {
    this.afAuth.authState.subscribe(user => {
      this.isAdmin = this.registrationService.getEmailsAdmin().includes(user?.email);
    })
    if (this.registrationVerifyInput) {
      this.registrationVerify = this.registrationVerifyInput;
    } else {
      this.loadDetailsRegistrationVerify();
    }
  }

  ngAfterViewInit() {
    if (this.registrationVerifyInput) {
      this.registrationVerify = this.registrationVerifyInput;
    }
  }

  loadDetailsRegistrationVerify() {
    this.id = this.route.snapshot.params['id'];
    this.registrationService.getDetailsRegistrationVerify(this.id).subscribe(data => {
      this.registrationVerify = { id: data.payload.id, ...data.payload.data() as RegistrationVerify };
    });
  }

  sendFeedback() {
    this.registrationService.updateRegistrationVerify(this.registrationVerify).then(data => {
      this.router.navigateByUrl("/danh-sach-dang-ky-kiem-hoa");
    });
  }

  cancel() {
    this.isEdit = false;
    this.loadDetailsRegistrationVerify();
  }
}
